'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var IconCart = function IconCart(_ref) {
  var color = _ref.color,
      custom = _objectWithoutProperties(_ref, ['color']);

  return _react2.default.createElement(
    'svg',
    _extends({ fill: 'none', height: '24', viewBox: '0 0 24 24', width: '24' }, custom),
    _react2.default.createElement(
      'g',
      { fill: color },
      _react2.default.createElement('path', { d: 'M8.05,16.5833333 C7.475,16.5833333 7,17.05 7,17.6333333 C7,18.2166667 7.475,18.6833333 8.05,18.6833333 C8.63333333,18.6833333 9.10833333,18.2166667 9.10833333,17.6333333 C9.10833333,17.05 8.63333333,16.5833333 8.05,16.5833333 Z M8.05,20.35 C6.55,20.35 5.33333333,19.1333333 5.33333333,17.6333333 C5.33333333,16.1333333 6.55,14.9166667 8.05,14.9166667 C9.55,14.9166667 10.775,16.1333333 10.775,17.6333333 C10.775,19.1333333 9.55,20.35 8.05,20.35 L8.05,20.35 Z' }),
      ' ',
      _react2.default.createElement('path', { d: 'M17.2166667,16.5833333 C16.6333333,16.5833333 16.1666667,17.05 16.1666667,17.6333333 C16.1666667,18.2166667 16.6333333,18.6833333 17.2166667,18.6833333 C17.8,18.6833333 18.2666667,18.2166667 18.2666667,17.6333333 C18.2666667,17.05 17.8,16.5833333 17.2166667,16.5833333 Z M17.2166667,20.35 C15.7166667,20.35 14.5,19.1333333 14.5,17.6333333 C14.5,16.1333333 15.7166667,14.9166667 17.2166667,14.9166667 C18.7166667,14.9166667 19.9333333,16.1333333 19.9333333,17.6333333 C19.9333333,19.1333333 18.7166667,20.35 17.2166667,20.35 L17.2166667,20.35 Z' }),
      ' ',
      _react2.default.createElement('path', { d: 'M15.65,18.25 L10.3333333,18.25 C9.875,18.25 9.5,17.875 9.5,17.4166667 C9.5,16.9583333 9.875,16.5833333 10.3333333,16.5833333 L15.65,16.5833333 C16.1083333,16.5833333 16.4833333,16.9583333 16.4833333,17.4166667 C16.4833333,17.875 16.1083333,18.25 15.65,18.25' }),
      ' ',
      _react2.default.createElement('path', { d: 'M7.78149803,16.2737782 C7.70649803,16.2737782 7.6231647,16.2571115 7.53983136,16.2321115 C7.0981647,16.0987782 6.8481647,15.6321115 6.98983136,15.1904448 L7.45649803,13.6904448 L4.7231647,5.48211149 L2.60649803,4.88211149 C2.16483136,4.75711149 1.90649803,4.29877816 2.03149803,3.85711149 C2.16483136,3.40711149 2.63149803,3.15711149 3.06483136,3.28211149 L5.5981647,4.00711149 C5.86483136,4.08211149 6.0731647,4.28211149 6.16483136,4.54044483 L9.1231647,13.4154448 C9.1731647,13.5821115 9.18149803,13.7571115 9.1231647,13.9237782 L8.58149803,15.6821115 C8.4731647,16.0404448 8.13983136,16.2737782 7.78149803,16.2737782' }),
      ' ',
      _react2.default.createElement('path', { d: 'M8.82782738,13.1416667 L18.6528274,13.1416667 L20.0528274,8.25 L7.30282738,8.25 L8.82782738,13.1416667 Z M18.844494,14.8083333 L8.21949405,14.8083333 C7.85282738,14.8083333 7.53616071,14.5666667 7.41949405,14.2166667 L5.36949405,7.65833333 C5.29449405,7.40833333 5.33616071,7.13333333 5.49449405,6.91666667 C5.65282738,6.70833333 5.90282738,6.58333333 6.16949405,6.58333333 L21.1528274,6.58333333 C21.419494,6.58333333 21.6611607,6.7 21.819494,6.90833333 C21.9778274,7.11666667 22.0278274,7.39166667 21.9611607,7.64166667 L20.269494,13.5416667 C20.2028274,14.2583333 19.6028274,14.8083333 18.844494,14.8083333 L18.844494,14.8083333 Z' }),
      ' ',
      _react2.default.createElement('path', { d: 'M18.8166667,9.91666667 L9.08333333,9.91666667 C8.85,9.91666667 8.66666667,9.725 8.66666667,9.5 C8.66666667,9.26666667 8.85,9.08333333 9.08333333,9.08333333 L18.8166667,9.08333333 C19.05,9.08333333 19.2333333,9.26666667 19.2333333,9.5 C19.2333333,9.725 19.05,9.91666667 18.8166667,9.91666667' }),
      ' ',
      _react2.default.createElement('path', { d: 'M18.3333333,11.5833333 L9.91666667,11.5833333 C9.69166667,11.5833333 9.5,11.4 9.5,11.1666667 C9.5,10.9333333 9.69166667,10.75 9.91666667,10.75 L18.3333333,10.75 C18.5666667,10.75 18.75,10.9333333 18.75,11.1666667 C18.75,11.4 18.5666667,11.5833333 18.3333333,11.5833333' }),
      ' '
    )
  );
};

IconCart.propTypes = {
  color: _propTypes2.default.string
};

IconCart.defaultProps = {
  color: _colors2.default.icons
};

IconCart.displayName = 'IconCart';

exports.default = IconCart;
module.exports = exports.default;